export const getFormattedEndereco = (endereco) => {
  const formattedEndereco = `
  ${endereco.endereco || ''}
  ${(endereco.endereco && endereco.bairro && ` - `) || ''}
  ${endereco.bairro || ''}
  ${(endereco.endereco || endereco.bairro) && endereco.cidade && `, `}
  ${endereco.cidade || ''}`
  return formattedEndereco
}
